export default "__VITE_ASSET__B7p9QMkW__"